<template>
    <div>
        <AlertText msg-key="notifications.alerts.combinedEE" :zone="zone" :time="time" />
    </div>
</template>

<script setup>
  import AlertText from './AlertText.vue'

  defineProps({
      zone: String,
      time: Number
  })
</script>
